
import { george, theme, helpers, pr, observable, observer } from "aaa";
import { withFormsy } from "formsy-react";
import * as React from "react";
import { IFormsyComponentProps } from "./FormsyProps";

interface IProps {
    isLoading?: boolean;
    value?: string;
    disabled?: boolean;
    white?: boolean;
    onChange?: (event: any, index: number, value: string) => void;
    onClick?: (event: any) => void;
    maxHeight?: number;
    children?: any;
    "aria-label"?: string;

    // Native means: native select instead of materialui DropDownMenu
    native?: boolean;

    // List of items for the dropdown (key = React key property, value = item value, label = displayed label)
    // Key is optional, if no key is provided then key=value
    items: { key?: string; value: string; label: string }[];
    style?: React.CSSProperties;
}

@observer
export class GeorgeDropDown extends React.Component<IProps> {
    button: any;
    dropdownUid: string;
    @observable focus = false;

    constructor(props: IProps) {
        super(props);
        // Create a random ID to identify the dropdown for DOM manipulation
        this.dropdownUid = Math.random().toString();
    }

    componentDidMount() {
        // Have to set aria-label like this because material-ui v0 does not forward aria-label to the button
        if (this.props["aria-label"]) {
            const root = document.getElementById(this.dropdownUid);
            if (root) {
                const button = root.getElementsByTagName("button")[0];
                if (button) {
                    this.button = button;
                    button.setAttribute("aria-label", this.props["aria-label"] as string);
                    button.onclick = () => {
                        this.button.setAttribute("aria-hidden", "true");
                    };
                }
            }
        }
    }

    renderNative() {
        let items;
        if (this.props.items) {
            items = this.props.items.map(item => {
                return <option key={item.key || item.value} value={item.value}>{item.label}</option>;
            });
        }

        return (
            <>
                <select
                    className={this.props.white ? undefined : "theme-dropdown-color"}
                    style={{
                        width: "100%",
                        fontSize: 16,
                        border: "none",
                        background: "none",
                        color: this.props.white ? "white" : undefined,
                        cursor: "pointer",
                        appearance: "none",
                        WebkitAppearance: "none",
                        outline: "none" // hide focus outline -> we render our own
                    }}
                    onChange={(event: any) => this.props.onChange && this.props.onChange(event, event.target.selectedIndex, event.target.value)}
                    onClick={(event: any) => this.props.onClick && this.props.onClick(event)}
                    value={this.props.value || ""}
                    disabled={this.props.disabled}
                    onFocus={() => this.focus = true}
                    onBlur={() => this.focus = false}
                >
                    {items ? items : this.props.children}
                </select>
                {!helpers.isIE() &&
                    <pr.IconDropDown
                        className={this.props.white ? undefined : "theme-dropdown-color"}
                        style={{
                            position: "absolute",
                            right: 10,
                            alignSelf: "center",
                            pointerEvents: "none",
                            color: this.props.white ? "white" : undefined
                        }}
                    />
                }
            </>
        );
    }

    isNative = () => {
        // We render a native select if forced, or we are on mobile AND we have items and their specs
        // return (this.props.native || helpers.isIos() || helpers.isAndroid()) && this.props.items;

        // Change requested August 2019 -> always render native for a11y reasons
        return this.props.items;
    }

    render() {
        const native = this.isNative();

        return (
            <george.InputFrame
                white={this.props.white}
                isLoading={this.props.isLoading}
                style={{
                    padding: 2,
                    ...(native ? {
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        paddingLeft: theme.MARGIN,
                        boxShadow: this.focus ? theme.focusShadow : "none",
                        transition: "box-shadow 0.2s"
                    } : {}),
                    ...this.props.style
                }}
                id={this.dropdownUid}
            >
                {!this.props.isLoading && native && this.renderNative()}
            </ george.InputFrame>
        );
    }
}

class FormsyDropDown extends React.Component<IFormsyComponentProps & IProps, {}> {
    changeValue = (event: any, index: number, value: string) => {
        if (this.props.onChange) {
            this.props.onChange(event, index, value);
        }

        // setValue() will set the value of the component, which in
        // turn will validate it and the rest of the form
        // Important: Don't skip this step. This pattern is required
        // for Formsy to work.
        this.props.setValue(value);
    }

    render() {
        return (
            <div>
                <GeorgeDropDown
                    isLoading={this.props.isLoading}
                    value={this.props.getValue() || this.props.value || ""}
                    disabled={this.props.disabled}
                    white={this.props.white}
                    onChange={this.changeValue}
                    aria-label={this.props["aria-label"]}
                    native={this.props.native}
                    items={this.props.items}
                >
                    {this.props.children}
                </GeorgeDropDown>

                <div>{this.props.getErrorMessage()}</div>
            </div>
        );
    }
}

export const GeorgeDropDownFormsy = withFormsy(FormsyDropDown);



// WEBPACK FOOTER //
// ./src/components/common/GeorgeDropDown.tsx